<template>
	<scale-box>
		<div class="content">
			<!--center-->
			<div class="center">
				<div class="center-header" style="z-index: 99">
					<div class="t1">
						<div style="font-size: 14px">商标总量</div>
						<div class="num">
							{{ brandTotal }}
						</div>
					</div>
					<div class="t2">
						<div style="font-size: 14px;">有效注册量</div>
						<div class="num">
							{{ regNum }}
						</div>
					</div>
					<div class="t3">
						<div style="font-size: 14px">当年申请量</div>
						<div class="num">{{ sumApply }}</div>
					</div>
				</div>
				<div class="back" @click="goBack">返回</div>
				<div class="main" :style="{height: type == 6 ? '1120px' : '1200px'}">
					<template v-if="type != 4 && type != 5">
						<div class="main-header">
							<div class="city" v-if="pageLevel == 2">{{ area[area.length - 1] }}</div>
							<div style="flex: 1;text-align: center;">
								<template v-if="queryParams.applyYear">
									<span v-if="type == 3 && pageLevel == 3" style="color: #FF4D4F;font-size: 24px;">*今年下证商标数量可能包含去年申请的商标</span>
									<span v-if="type == 3 && pageLevel == 4" style="color: #FF4D4F;font-size: 24px;">*仅展示当年申请的商标</span>
								</template>	
							</div>
							<div class="class">
								<span>{{title}}</span>
								<span v-if="pageLevel == 4" style="color: #18F8FF;">({{total}}个商标)</span>
								<!-- <br /> -->
								<!-- <span style="font-size: 16px;">{{titleEn}}</span> -->
							</div>
							<div style="margin-left: 40px;display: flex;" v-if="type == 2">
								<div class="apply" :class="active == '0' ? 'active' : ''" @click="active = 0">申请量</div>
								<div class="reg" :class="active == '1' ? 'active' : ''" @click="active = 1">注册量</div>
							</div>
						</div>
						<div style="position: absolute;" v-if="pageLevel == 2 || (pageLevel == 3 && type != 1)">
							<div style="
							  position: relative;
							  overflow: hidden;
							  cursor: pointer;
							  border: 1px solid #4095E9;
							  height: 40px;
							  width: 120px;
							  text-align: center;
							  line-height: 40px;
							  padding: 5px 15px;
							  border-radius: 3px;
							  top: 17px;
							  left: 180px;
							">
								<div style="color: #F5E055; font-size: 20px;font-weight: bold;">
									<template v-if="queryParams.applyYear">{{ queryParams.applyYear }}年</template>
									<template v-else>全部年份</template>
								</div>
								<el-date-picker style="opacity: 0; position: absolute; top: 0; left: 0" v-model="queryParams.applyYear" type="year" size="mini"
									format="yyyy" value-format="yyyy" placeholder="请选择年份" :picker-options="pickerOptions" @change="yearChange">
								</el-date-picker>
							</div>
						</div>
						<div class="main-content">
							<template v-if="type != 6">
								<div style="display: flex;height: 100%;">
									<template v-if="pageLevel == 3">
										<div v-if="type == 1" style="height: 100%;width: 100%;display: flex;">
											<chart style="height: 100%;flex-basis: 70%;" class="block" :option="option5" />
											<div style="flex-basis: 30%;padding-top: 180px;text-align: center;">
												<div>
													<div style="font-size: 24px;margin-bottom: 24px;">今年相比于去年同比增幅
														<span style="color: #91CAFF">(申请量)</span>
													</div>
													<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: appReg.app_tongbi > 0 ? '#FF4D4F' : '#52C41A'}">
														<img v-if="appReg.app_tongbi > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
														<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
														<span>{{appReg.app_tongbi + '%'}}</span>
													</div>
												</div>
												<div style="margin-top: 85px;">
													<div style="font-size: 24px;margin-bottom: 24px;">本季度相比于上季度环比增幅
														<span style="color: #91CAFF">(申请量)</span>
													</div>
													<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: appReg.app_huanbi > 0 ? '#FF4D4F' : '#52C41A'}">
														<img v-if="appReg.app_huanbi > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
														<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
														<span>{{appReg.app_huanbi + '%'}}</span>
													</div>
												</div>
												<div style="margin-top: 120px;">
													<div style="font-size: 24px;margin-bottom: 24px;">今年相比于去年同比增幅
														<span style="color: #FFFB8F">(注册量)</span>
													</div>
													<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: appReg.reg_tongbi > 0 ? '#FF4D4F' : '#52C41A'}">
														<img v-if="appReg.reg_tongbi > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
														<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
														<span>{{appReg.reg_tongbi + '%'}}</span>
													</div>
												</div>
												<div style="margin-top: 85px;">
													<div style="font-size: 24px;margin-bottom: 24px;">本季度相比于上季度环比增幅
														<span style="color: #FFFB8F">(注册量)</span>
													</div>
													<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: appReg.reg_huanbi > 0 ? '#FF4D4F' : '#52C41A'}">
														<img v-if="appReg.reg_huanbi > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
														<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
														<span>{{appReg.reg_huanbi + '%'}}</span>
													</div>
												</div>
											</div>
										</div>
										<div v-else-if="type == 3" style="height: 100%;width: 100%;">
											<SwiperList4 :year="queryParams.applyYear" :page="page" :data="option4" style="height: 85%;" @goLevel4="goLevel4"></SwiperList4>
											<div class="pagination" style="margin-top: 30px;">
												<el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4" :current-page="page"
												 :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, pager, jumper" :total="total">
												</el-pagination>
											</div>
										</div>
										<div v-else-if="type == 8" style="height: 100%;width: 100%;">
											<SwiperList4 :year="queryParams.applyYear" :page="page" :data="option4" style="height: 85%;" @goLevel4="goLevel4"></SwiperList4>
											<div class="pagination" style="margin-top: 30px;">
												<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="page"
												 :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, pager, jumper" :total="total">
												</el-pagination>
											</div>
										</div>
									</template>
									<template v-else-if="pageLevel == 4">
										<div style="display: flex;flex-direction: column;width: 100%;">
											<SwiperList6 :year="queryParams.applyYear" :page="page" :data="option7" style="height: 85%;"></SwiperList6>
											<div class="pagination" style="margin-top: 30px;">
												<el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5" :current-page="page"
												 :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, pager, jumper" :total="total">
												</el-pagination>
											</div>
										</div>
									</template>
									<template v-else>
										<chart style="height: 100%" class="block" :option="option" @areaClick="areaClick" />
									</template>
									<div v-if="type == 3 && pageLevel == 2" style="flex-basis: 30%;padding-top: 300px;text-align: center;">
										<div>
											<div style="font-size: 24px;margin-bottom: 24px;">{{ area[area.length - 1] }}新增较去年拥有商标的企业</div>
											<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: increase > 0 ? '#FF4D4F' : '#52C41A'}">
												<img v-if="increase > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
												<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
												<span>{{increase}}</span>
											</div>
										</div>
										<div style="margin-top: 85px;">
											<div style="font-size: 24px;margin-bottom: 24px;">增幅</div>
											<div style="font-size: 28px;font-weight: bold;display: flex;align-items: center;justify-content: center;" :style="{color: increase > 0 ? '#FF4D4F' : '#52C41A'}">
												<img v-if="increase > 0" style="margin-right: 15px;" src="../../assets/2/up.png" width="44" height="24" alt="">
												<img v-else style="margin-right: 15px;" src="../../assets/2/down.png" width="44" height="24" alt="">
												<span>{{increasePercent}}</span>
											</div>
										</div>
									</div>									
								</div>
							</template>							
							<template v-else>
								<SwiperList3 :year="queryParams.applyYear" :page="page" :data="option2" style="height: 85%;"></SwiperList3>
							</template>
						</div>						
					</template>
					<!-- 45 -->
					<template v-else>
						<div class="main-header">
							<div class="city" v-if="pageLevel == 2">{{ area[area.length - 1] }}</div>
							<div style="flex: 1;" v-if="pageLevel == 2"></div>
							<div class="class">
								<span>{{title}}</span>
								<br />
								<!-- <span style="font-size: 16px;">{{titleEn}}</span> -->
							</div>
						</div>
						<div style="position: absolute;">
							<div style="
							  position: relative;
							  overflow: hidden;
							  cursor: pointer;
							  border: 1px solid #4095E9;
							  height: 40px;
							  width: 120px;
							  text-align: center;
							  line-height: 40px;
							  padding: 5px 15px;
							  border-radius: 3px;
							  top: 17px;
							  left: 250px;
							">
								<div style="color: #F5E055; font-size: 20px;font-weight: bold;">
									<template v-if="queryParams.applyYear">{{ queryParams.applyYear }}年</template>
									<template v-else>全部年份</template>
								</div>
								<el-date-picker style="opacity: 0; position: absolute; top: 0; left: 0" v-model="queryParams.applyYear" type="year" size="mini"
									format="yyyy" value-format="yyyy" placeholder="请选择年份" :picker-options="pickerOptions" @change="yearChange">
								</el-date-picker>
							</div>
						</div>
						<template v-if="pageLevel == 3">
							<SwiperList5 :year="queryParams.applyYear" :intcls="intcls" :page="page" :data="option6" style="height: 85%;"></SwiperList5>
							<div class="pagination" style="margin-top: 30px;">
								<el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="page"
								 :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, pager, jumper" :total="total">
								</el-pagination>
							</div>
						</template>
						<template v-else>
							<div class="main-content" style="flex-basis: 10%;">
								<chart style="height: 100%" class="block" :option="option" @areaClick="areaClick" />
							</div>
							<div class="main-header">
								<div style="flex: 1;"></div>
								<div class="class">
									<span>{{title2}}</span>
									<br />
									<!-- <span style="font-size: 16px;">{{title2En}}</span> -->
								</div>
							</div>
							<div class="main-content">
								<chart style="height: 100%" class="block" :option="option3" />
							</div>
						</template>				
					</template>
				</div>
				<div class="pagination" v-if="type == 6">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
					 :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, pager, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</scale-box>
</template>

<script>
	import scaleBox from "@/components/sclae-box";
	import Chart from "@/components/chart.vue";
	import SwiperList3 from "@/components/swiper-list3";
	import SwiperList4 from "@/components/swiper-list4";
	import SwiperList5 from "@/components/swiper-list5";
	import SwiperList6 from "@/components/swiper-list6";
	import {
		centerData,
		getTrademarkTendencyChart,
		leftBottomData,
		leftCenterData,
		leftTopData,
		leftTopData1,
		rightCenterData2,
		rightTopBottomData,
		getDataAnalysisYear,
		getEnterpriseDataDetailTwo,
		getTrademarkTradeDataThree,
		getTrademarkAreaDataThree,
		getTrademarkCategoryDataThree,
		getEnterpriseDataDetailThree,
		getApplicantTrademark
	} from "@/api/dataView";
	import {
		getChartOption
	} from "@/libs/chart_options";
	import {
		Arg
	} from "@/libs/arg.js"

	export default {
		name: "dataScreenView",
		data() {
			return {
				page: 1,
				pageLevel: 2,
				size: 10,
				total: 0,
				sumApply: 0,
				brandTotal: 0,
				regNum: 0,
				active: 0,
				option: {},
				option2: [],
				option3: {},
				option4: [],
				option5: {},
				option6: [],
				option7: [],
				rcData: [],
				area: [],
				zhixiashi: ["北京市", "上海市", "天津市", "重庆市"],
				queryParams: {
					applyYear: "",
					level: "",
					province: "",
					city: "",
					county: "",
				},
				type: 0,
				title: '',
				titleEn: '',
				title2: '',
				title2En: '',
				industry: '',
				intcls: '',
				county: '',
				rightTopIndex: 0,
				rightTopTimer: null,
				increase: 0,
				increasePercent: '0%',
				appReg: {
					app_tongbi: 0,
					app_huanbi: 0,
					reg_tongbi: 0,
					reg_huanbi: 0,
				},
				pickerOptions: {
					shortcuts: [{
						text: "全部年份",
						onClick(picker) {
							// console.log(picker)
							picker.$emit("pick", "");
						},
					}],
				},
			};
		},
		created() {
			if (!Arg.queryParams.level) return this.$router.push('/')
			this.queryParams = Arg.queryParams
			this.area = Arg.queryParams.area
			this.type = this.$route.query.type
			this.getRightBottomData(1)
			this.getCenterTopData()
			this.init()
		},
		computed: {

		},
		mounted() {
			if (this.type == 4 || this.type == 5) this.initRightTopSwiper();
		},
		methods: {			
			init() {				
				this.pageLevel = 2
				switch (this.type) {
					case '1':
						this.getLeftTop1()
						this.title = '商标地区分布'
						this.titleEn = 'Regional Distribution'
						break;
					case '2':
						this.getLeftTop()
						this.title = '城市商标排名'
						this.titleEn = 'City Trademark Ranking'
						break;
					case '3':
						this.getLeftCenter()
						this.title = '拥有商标企业'
						this.titleEn = 'Companies with Trademarks'
						break;
					case '4':
					case '5':
						this.getRightCenter(false)
						this.title = '商标类别排行'
						this.titleEn = 'Trademark Category Ranking'
						this.getRightCenter(1)
						this.title2 = '产品/服务分布'
						this.title2En = 'Product Distribution'
						break;
					case '6':
						this.getRightTopBottom()
						this.title = '申请量TOP100'
						this.titleEn = 'Registration Ranking'
						break;
					case '7':
						this.getRightBottomData()
						this.title = '成功率趋势'
						this.titleEn = 'The Success Rate'
						break;
					case '8':
						this.getLeftBottom()
						this.title = '商标行业排名'
						this.titleEn = 'Industry Ranking'
						break;
					default:
						break;
				}
			},		
			areaClick(name) {	
				// console.log(name)
				if (this.type == 1) {
					this.pageLevel = 3
					this.title = name
					this.getTrademarkAreaDataThree(name)
				} else if (this.type == 3) {
					this.pageLevel = 3
					this.title = name
					this.getEnterpriseDataDetailThree(name)
				} else if (this.type == 4 || this.type == 5) {
					this.pageLevel = 3
					this.title = name
					this.getTrademarkCategoryDataThree(name)			
				} else if (this.type == 8) {
					this.pageLevel = 3
					this.title = name
					this.getTrademarkTradeDataThree(name)
				}
			},
			goLevel4(row) {
				console.log(row)
				if (this.type == 3 || this.type == 8) {
					this.page = 1
					this.pageLevel = 4
					this.title = row.tmApplicant
					this.getApplicantTrademark(row)
				}
			},
			goBack() {
				if (this.pageLevel == 4) {
					this.page = 1
					this.pageLevel = 3
					if (this.type == 3) this.title = this.county
					return
				}
				if (this.pageLevel == 3) {
					this.page = 1
					this.pageLevel = 2
					if (this.type == 1)	this.title = '商标地区分布'
					else if (this.type == 8) this.title = '商标行业排名'
					return
				}
				this.$router.back()
			},
			yearChange(year) {
				this.queryParams.applyYear = year
				this.page = 1
				if (this.pageLevel == 2) this.init()
				else this.areaClick(this.title)
			},			
			async getApplicantTrademark(row) {
				let res = await getApplicantTrademark({
					...this.getQueryParams(this.queryParams),
					applicant: this.title,
					level: 3,
					from: this.page - 1,
					size: this.size
				})
				this.option7 = res.data.data
				this.total = res.data.data[0].total
			},		
			async getEnterpriseDataDetailThree(name) {		
				if (name) this.county = name
				let res = await getEnterpriseDataDetailThree({
					...this.getQueryParams(this.queryParams),
					county: this.county,
					level: 4,
					from: this.page - 1,
					size: this.size
				})
				this.option4 = res.data.data
				this.total = res.data.data[0].total
			},					
			async getTrademarkCategoryDataThree(name) {
				if (name) this.intcls = name.slice(0, 2)
				let res = await getTrademarkCategoryDataThree({
					...this.getQueryParams(this.queryParams),
					intcls: this.intcls,
					from: this.page - 1,
					size: this.size
				})
				this.option6 = res.data.data
				this.total = res.data.data[0].total
			},			
			async getTrademarkAreaDataThree(name) {
				let month = new Date().getMonth() + 1
				let res = await getTrademarkAreaDataThree({
					...this.getQueryParams(this.queryParams),
					county: name,
					level: name ? 4 : 3,
					applyMonth: month
				})
				let data = res.data.data
				this.appReg.app_tongbi = Number(data.app_tongbi).toFixed(2)
				this.appReg.app_huanbi = Number(data.app_huanbi).toFixed(2)
				this.appReg.reg_tongbi = Number(data.reg_tongbi).toFixed(2)
				this.appReg.reg_huanbi = Number(data.reg_huanbi).toFixed(2)
				this.option5 = getChartOption("rightBottom", {
					xData: data.data.map((i) => i.applyYear),
					yData: [
						data.data.map((i) => i.applyCnt - 0),
						data.data.map((i) => i.regCnt - 0),
					],
					grid: {
						left: '10%',
						right: '10%',
						bottom: '80',
						top: '10%'
					},
					XaxisLabel: {
						color: '#fff',
						formatter: value => value.replace(/\s/g, '\n'),
						textStyle: {
							fontSize: 24
						}
					},
					yAxis1: {
						type: 'value',
						axisLine: {
							show: false,
						},
						axisLabel: {
							color: '#fff',
							textStyle: {
								fontSize: 24
							}
						},
						splitLine: {
							show: false,
							lineStyle: {
								type: 'dashed',
								color: '#CCCCCC',
								opacity: 0.3,
							}
						},
					},
					yAxis2: {
						type: 'value',
						name: '',
						axisLine: {
							show: false,
						},
						min: 0,
						max: 100,
						axisLabel: {
							show: false,
						},
						splitLine: {
							show: false,
							lineStyle: {
								type: 'dashed',
								color: '#CCCCCC',
								opacity: 0.3,
							}
						},
					},
					YLabel1: {
						show: true,
						position: 'top',
						color: '#F5E055',
						textStyle: {
							fontSize: 24,
							fontWeight: 'bold'
						}
					},
					YLabel2: {
						show: true,
						position: 'top',
						color: '#91CAFF',
						textStyle: {
							fontSize: 24,
							fontWeight: 'bold'
						}
					},
					legend: {
						textStyle: {
							color: '#fff',
							fontSize: 24
						},
						right: 280
					},
					barWidth: 20,
					fontSize: 24,
					symbolSize: 15,
					lv: true
				});
			},
			async getTrademarkTradeDataThree(name) {
				if (name) this.industry = name
				let res = await getTrademarkTradeDataThree({
					...this.getQueryParams(this.queryParams),
					industry: this.industry || name,
					from: this.page - 1,
					size: this.size
				})
				this.option4 = res.data.data
				this.total = res.data.data[0].total
			},
			handleSizeChange(val) {
				this.size = val
				this.getRightTopBottom()
			},
			handleCurrentChange(val) {
				this.page = val
				this.getRightTopBottom()
			},
			handleSizeChange2(val) {
				this.size = val
				this.getTrademarkTradeDataThree()
			},
			handleCurrentChange2(val) {
				this.page = val
				this.getTrademarkTradeDataThree()
			},
			handleSizeChange3(val) {
				this.size = val
				this.getTrademarkCategoryDataThree()
			},
			handleCurrentChange3(val) {
				this.page = val
				this.getTrademarkCategoryDataThree()
			},
			handleSizeChange4(val) {
				this.size = val
				this.getEnterpriseDataDetailThree()
			},
			handleCurrentChange4(val) {
				this.page = val
				this.getEnterpriseDataDetailThree()
			},
			handleSizeChange5(val) {
				this.size = val
				this.getApplicantTrademark()
			},
			handleCurrentChange5(val) {
				this.page = val
				this.getApplicantTrademark()
			},
			initRightTopSwiper() {
				clearInterval(this.rightTopTimer);
				this.rightTopTimer = setInterval(() => {
					if (this.rightTopIndex > 8) {
						this.rightTopIndex = 0;
					} else {
						this.rightTopIndex = this.rightTopIndex + 1;
					}
					let arr = [...this.option.series[0].data].map((i) => {
						i.itemStyle = {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: "#91CAFF"
									},
									{
										offset: 1,
										color: "#002C8C"
									}
								]
							},
							barBorderRadius: [0, 0, 0, 0],
						}
						return i;
					});
					let arr2 = [...this.option.series[1].data].map((i) => {
						i.itemStyle = {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: "#FFFB8F"
									},
									{
										offset: 1,
										color: "#876800"
									}
								]
							},
							barBorderRadius: [0, 0, 0, 0],
						}
						return i;
					});
					if (typeof arr[this.rightTopIndex] === "object") {
						arr[this.rightTopIndex] = {
							value: arr[this.rightTopIndex].value,
							itemStyle: {
								borderColor: "#48A1ED",
								borderWidth: 10,
								borderType: "solid",
								color: "#48A1ED",
							},
						};
						arr2[this.rightTopIndex] = {
							value: arr2[this.rightTopIndex].value,
							itemStyle: {
								borderColor: "#efe87c",
								borderWidth: 10,
								borderType: "solid",
								color: "#efe87c",
							},
						};
					}
					this.option.series[0].data = arr;
					this.option.series[1].data = arr2;
				}, 5000);
			},
			//商标地区分布top5+其他
			async getLeftCenter() {
				let res = await leftCenterData((this.getQueryParams(this.queryParams)));
				let queryParams = JSON.parse(JSON.stringify(this.queryParams))
				queryParams.level = queryParams.level - 1
				let res2= await getEnterpriseDataDetailTwo(queryParams)
				if (res2.data.data && res2.data.data.length != 0) {
					this.increase = res2.data.data[0].increase
					this.increasePercent = Number(res2.data.data[0].increasePercent * 100).toFixed(2) + '%';
				}
				let props = {
					0: "province",
					1: "city",
					2: "county",
					3: "county",
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				if (level == 4) level = 3;
				if (res.data.data) {
					let result = {};
					res.data.data.forEach((i) => {
						if (i[props[level]] !== "其他") {
							result[i[props[2]]] = i["tmapplicantCnt"];
						}
						// console.log(result)
					});
					this.option = getChartOption("leftCenter", {
						xData: Object.keys(result),
						yData: Object.values(result),
						grid: {
							top: '10%',
							left: '20%',
							right: '10%',
							bottom: '20%'
						},
						barWidth: 27,
						XaxisLabel: {
							interval: 0,
							margin: 40,
							color: '#fff',
							formatter: value => value.replace(/\s/g, '\n'),
							textStyle: {
								fontSize: 24
							},
						},
						YaxisLabel: {
							interval: 0,
							margin: 40,
							color: '#fff',
							textStyle: {
								fontSize: 24
							},
						},
						fontSize: 24
					});
					return result;
				}
				return {};
			},
			async getRightTopBottom(name = "") {
				// 数据根据 区域变化 通过子组件过来 onUpDataRightBottom => name 不为空
				// console.log(name,123)
				let res = await rightTopBottomData({
					...this.getQueryParams(this.queryParams),
					county: name,
					level: name ? 4 : 3,
					from: this.page - 1,
					size: this.size
				});
				if (res.data.data && res.data.data.length != 0) {
					this.total = res.data.data[0].total
					this.option2 = res.data.data.map((i) => {
						return {
							name: i.tmapplicant,
							value: i.applyCnt,
						};
					});
				}
				return {};
			},
			async getRightCenter(flag) {
				var res;
				if (this.area.length == 3) {
					this.queryParams.county = this.area[2];
					this.queryParams.level = "4";
					res = await rightCenterData2((this.queryParams));
				} else {
					res = await rightCenterData2((this.getQueryParams(this.queryParams)));
				}

				if (res.data.data) {
					let result = {};
					let result2 = {};
					let arr = res.data.data;
					this.rcData = arr;
					if (flag) {
						let rcData = this.rcData[0].tmdetail.split(';')
						let data = []
						rcData.forEach((item, index) => {
							let cnt = item.slice(0, item.indexOf(':'))
							let detail = item.slice(item.indexOf(':') + 1)
							data[index] = {
								value: detail,
								name: cnt
							}
						})						
						data = data.sort((a, b) => a.value - b.value)
							.splice(0, 5);
						let rightTopData = data.map(i => {
							i.value = i.value
							i.name = i.name
							return i
						})
						this.option3 = getChartOption("rightTop", {
							xData: data.map((i) => i.detail),
							yData: rightTopData,
							fontSize: 24
						});
					} else {
						let data1 = [], data2 = []
						arr.forEach((i) => {
							let key = i["intcls"] + "类" + i["categoryName"];
							result[key] = i["applyCnt"];
							// result2[key] = i["intcls"];
							data1.push({
								value: i.applyCnt,
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [
											{
												offset: 0,
												color: "#91CAFF"
											},
											{
												offset: 1,
												color: "#002C8C"
											}
										]
									},
									barBorderRadius: [0, 0, 0, 0],
								},
							})
							data2.push({
								value: i.validCnt,
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [
											{
												offset: 0,
												color: "#FFFB8F"
											},
											{
												offset: 1,
												color: "#876800"
											}
										]
									},
									barBorderRadius: [0, 0, 0, 0],
								},
							})
						});
						this.option = getChartOption("rightCenter", {
							xData: Object.keys(result),
							yData: Object.values(result),
							legend: true,
							series: [
							    {
									name: '申请量',
									type: 'bar',
									data: data1,
									itemStyle: {
										color: "#91CAFF"
									},
							    },
							    {
									name: '注册量',
									type: 'bar',
									data: data2,
									itemStyle: {
										color: "#FFFB8F"
									},
							    }
							],							
							emphasis: {
							    focus: 'series'
							},
							grid: {
								top: '5%',
								left: '10%',
								right: '10%',
								bottom: '20%'
							},
							barWidth: 20,
							// barBorderRadius: [8, 8, 0, 0],
							Xmargin: 50,
							Xalign: 'center',
							fontSize: 24
						});
					}
				}
				return {};
			},
			async getLeftBottom() {
				var res;
				if (this.area.length == 3) {
					this.queryParams.county = this.area[2];
					this.queryParams.level = "4";
					res = await leftBottomData((this.queryParams));
				} else {
					res = await leftBottomData((this.getQueryParams(this.queryParams)));
				}

				if (res.data.data) {
					let result = {};
					res.data.data.forEach((i) => {
						result[i["industry"]] = i["applyCnt"];
					});
					let leftBottomData = []
					for (let key in result) {
						leftBottomData.push({
							name: key,
							value: result[key]
						})
					}
					this.option = getChartOption("leftBottom", {
						yData: leftBottomData,
						xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].reverse(),
						XaxisLabel: {
							color: '#fff',
							textStyle: {
								fontSize: 24
							},
						},
						YaxisLabel: {
							color: '#fff',
							textStyle: {
								fontSize: 24
							},
						},
						formatter: '{a|{c0}} {b0}',
						rich: {
							a: {
								color: '#F5E055',
								fontSize: 32,
								fontWeight: 'bold',
								padding: [0, 10]
							},
						},
						labelPositon: 'right',
						barWidth: 20,
						fontSize: 24
					});
				}
				return {};
			},
			async getLeftTop1() {
				let res = await leftTopData1((this.getQueryParams(this.queryParams)));
				let props = {
					0: "province",
					1: "city",
					2: "county",
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				if (level == 4) level = 3;
				if (res.data.data) {
					let leftTop1 = res.data.data.map((i) => {
						return {
							name: i.county,
							value: i.applyCnt,
						};
					});
					this.option = getChartOption("leftTop", {
						yData: leftTop1,
						Sradius: [120, 380],
						fontSize: 24
					});
				}
				return [];
			},
			async getRightBottomData(init) {
				let params = {
					...(this.getQueryParams(this.queryParams)),
				};
				var res;
				if (this.area.length == 3) {
					params.county = this.area[2];
					params.level = "4";
					if (params.applyYear === "") params.applyYear = "2023"
					res = await getTrademarkTendencyChart(params);
				} else {
					if (params.applyYear === "") params.applyYear = "2023"
					res = await getTrademarkTendencyChart((this.getQueryParams(params)));
				}
				if (res.data.data) {
					this.sumApply = res.data.data[0].sumApply;
					if (init) return
					let rightBottom = res.data.data;
					this.option = getChartOption("rightBottom", {
						xData: rightBottom.map((i) => i.applyYear),
						yData: [
							rightBottom.map((i) => i.sumApply - 0),
							rightBottom.map((i) => i.sumValid - 0),
							rightBottom.map((i) =>
								((i.sumValid / i.sumApply) * 100).toFixed(2)
							),
						],
						grid: {
							left: '10%',
							right: '10%',
							bottom: '50',
							top: '10%'
						},
						XaxisLabel: {
							color: '#fff',
							formatter: value => value.replace(/\s/g, '\n'),
							textStyle: {
								fontSize: 24
							}
						},
						yAxis1: {
							type: 'value',
							axisLine: {
								show: false,
							},
							axisLabel: {
								color: '#fff',
								textStyle: {
									fontSize: 24
								}
							},
							splitLine: {
								show: false,
								lineStyle: {
									type: 'dashed',
									color: '#CCCCCC',
									opacity: 0.3,
								}
							},
						},
						yAxis2: {
							type: 'value',
							name: '',
							axisLine: {
								show: false,
							},
							min: 0,
							max: 100,
							axisLabel: {
								show: false,
							},
							splitLine: {
								show: false,
								lineStyle: {
									type: 'dashed',
									color: '#CCCCCC',
									opacity: 0.3,
								}
							},
						},
						YLabel1: {
							show: true,
							position: 'top',
							color: '#F5E055',
							textStyle: {
								fontSize: 24,
								fontWeight: 'bold'
							}
						},
						YLabel2: {
							show: true,
							position: 'top',
							color: '#fff',
							textStyle: {
								fontSize: 24,
								fontWeight: 'bold'
							}
						},
						legend: {
							textStyle: {
								color: '#fff',
								fontSize: 24
							},
							right: 280
						},
						barWidth: 20,
						fontSize: 24,
						symbolSize: 15,
						barGap: '80%',
						barCategoryGap: '100%',
					});
					this.option.series[0].data = rightBottom.map(
						(i) => i.sumApply
					);
					this.option.series[1].data = rightBottom.map(
						(i) => i.sumValid
					);
					this.option.series[2].data = rightBottom.map((i) =>
						((i.sumValid / i.sumApply) * 100).toFixed(2)
					);
				}
			},
			//商标地区分布top5+其他
			async getLeftTop() {
				let res = await leftTopData1((this.getQueryParams(this.queryParams)));
				let props = {
					0: "province",
					1: "city",
					2: "county"
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				if (level == 4) level = 3;
				if (res.data.data) {
					let leftTop = res.data.data.map((i) => {
						return {
							name: i.county,
							value: this.active == 0 ? i.applyCnt : i.validCnt,
						};
					}).filter((i) => i.name !== "其他")
					leftTop = leftTop.sort((a, b) => b.value - a.value);
					let xData = []
					for (var i = 0; i < leftTop.length; i++) {
						xData.push(i + 1)
					}
					this.option = getChartOption("leftTopBottom", {
						xData: xData.reverse(),
						yData: Object.values(leftTop),
						grid: {
							top: '10%',
							left: '10%',
							right: '10%',
							bottom: '10%'
						},
						formatter: '{a|{c0}} {b|{b0}}',
						rich: {
							a: {
								color: '#F5E055',
								fontSize: 24,
								fontWeight: 'bold',
								padding: [0, 10]
							},
							b: {
								color: '#FFFFFF',
								fontSize: 24,
								fontWeight: 'bold',
							}
						},
						emphasis: {
							color: '#8ec7fd',
						},
						barWidth: 27,
						// barBorderRadius: [8, 8, 0, 0],
						Xmargin: 50,
						Xalign: 'center',
						fontSize: 32
					});
				}
				return [];
			},
			async getCenterTopData() {
				// this.queryParams.type = 0
				let params = {
					...(this.getQueryParams(this.queryParams)),
				};
				params.applyYear = "";
				let res = await getTrademarkTendencyChart(params);
				if (res.data.data) {
					let {
						sumApply,
						sumValid
					} = res.data.data[0];
					this.brandTotal = sumApply;
					this.regNum = sumValid;
				}
			},
			getQueryParams(value) {
				if (value.level == 4) {
					value.level = 3
				}
				return value
			},
		},
		destroyed() {
			clearInterval(this.rightTopTimer);
		},
		watch: {
			active(e) {
				this.getLeftTop()
				this.title = '城市商标排名'
			},
			rightTopIndex(e) {
				// 直接错误处理 在三级地图时候 有找不到details逻辑错误
				try {
					let rcData = this.rcData[e].tmdetail.split(';')
					let data = []
					rcData.forEach((item, index) => {
						let cnt = item.slice(0, item.indexOf(':'))
						let detail = item.slice(item.indexOf(':') + 1)
						data[index] = {
							value: detail,
							name: cnt
						}
					})						
					data = data.sort((a, b) => a.value - b.value)
						.splice(0, 5);
					let rightTopData = data.map(i => {
						i.value = i.value
						i.name = i.name
						return i
					})

					this.option3 = getChartOption("rightTop", {
						xData: data.map((i) => i.detail),
						yData: rightTopData,
						fontSize: 24
					});
				} catch (e) {

				}
			},
		},
		components: {
			scaleBox,
			SwiperList3,
			SwiperList4,
			SwiperList5,
			SwiperList6,
			Chart
		},
	};
</script>

<style lang="less" scoped>
	.header {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		// background-color: #02234d;
		font-size: 24px;
	}

	.color {
		color: #18F8FF;
	}

	.content {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		background-image: url(../../assets/2/bg4.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		margin: 0;
		color: #fff;
		position: relative;

		.center {
			flex: 1;
			width: 100%;
			overflow: hidden;
			position: relative;
			flex-wrap: wrap;

			.back {
				width: 120px;
				height: 40px;
				background: #002C8C;
				box-shadow: inset 0px 5px 15px 1px #1890FF;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				border: 1px solid #1890FF;
				font-size: 20px;
				font-weight: 500;
				color: #FFFFFF;
				text-align: center;
				line-height: 40px;
				position: absolute;
				top: 40px;
				right: 120px;
				cursor: pointer;
			}
		}

	}

	.center-header {
		display: flex;
		background-image: url(../../assets/2/center1.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		height: 56px;
		width: 830px;
		margin: 48px auto 0 auto;
		justify-content: space-around;
		// padding-top: 10px;

		&>div {
			text-align: center;
		}

		.t1,
		.t2,
		.t3 {
			background-size: 40px 40px;
			background-repeat: no-repeat;
			background-position-y: 5px;
			padding-left: 20px;
		}

		.num {
			font-weight: bold;
			font-size: 26px;
			color: #BAE0FF;
			margin-top: 8px;
		}
	}

	.main {
		background-image: url(../../assets/2/bg5.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 2000px;
		height: 1120px;
		margin: 10px auto 0 auto;
		padding: 60px 200px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.main-header {
			display: flex;
			margin-top: 20px;

			.city {
				font-size: 43px;
				font-weight: bold;
				color: #FFFFFF;
			}

			.class {
				font-size: 37px;
				font-weight: bold;
				color: #FFFFFF;
			}
		}

		.main-content {
			flex: 1;
		}
		
		.apply {
			background-image: url(../../assets/2/noactiveL.png);
			&.active {
				background-image: url(../../assets/2/activeL.png);
			}
		}
		
		.reg {
			background-image: url(../../assets/2/noactiveR.png);
			&.active {
				background-image: url(../../assets/2/activeR.png);
			}
		}
		
		.apply, .reg {			
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: 120px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
			cursor: pointer;			
		}
	}

	.pagination {
		background-image: url(../../assets/2/pagination.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 1360px;
		height: 60px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
<style lang="less">
	.content {
		.pagination {
			.el-pagination__total {
				font-size: 20px;
				color: #FFFFFF;
			}

			.el-pagination__jump {
				font-size: 20px;
				color: #FFFFFF;
			}

			.el-pagination__sizes .el-input__inner {
				background: none;
				font-size: 20px;
				color: #FFFFFF;
				// border: 1px solid #18F8FF;
				width: 130px;
			}

			.el-pagination .el-select .el-input {
				width: 130px;
			}

			.el-pagination__jump .el-input__inner {
				background: none;
				font-size: 20px;
				color: #FFFFFF;
				// border: 1px solid #18F8FF;
				width: 80px;
			}

			.el-pagination__editor.el-input {
				width: 80px;
				margin: 0 10px;
			}

			.el-pagination__sizes {
				width: 150px;
			}

			.el-pager li {
				background: none;
				color: white;
				font-size: 20px;
			}

			.el-pager li.active {
				color: #18F8FF;
			}
		}
	}
</style>
